export default {
    request: function(req, authTokens) {
        let tokens = authTokens.split(';')

        this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + tokens[0] })

        if (req.url.indexOf('refresh-token') !== -1) {
            req.data = {
                refresh_token: tokens[1],
            }
        }
    },

    response: function(res) {
        if (res.data.access_token && res.data.refresh_token) {
            return res.data.access_token + ';' + res.data.refresh_token
        }
    },
}
